import { getCookie } from "@/utils/cookie-utils";
import { IS_DEMO_BUILD } from "@/utils/supabase/config";

/**
 * True when the browser is pointed at the DEMO database (db_env cookie, the same
 * one DatabaseContext and the Supabase client read). The demo only exists in
 * development, so production builds always get false. On the server (no
 * document) it is false too: callers that render differently must check it
 * after mount to avoid hydration mismatches.
 *
 * Prefer useInternalFeatures() inside components that have the app providers;
 * this helper is for code outside them (error boundaries, root layouts).
 */
export const isDemoDatabase = (): boolean => {
  if (IS_DEMO_BUILD) return true;
  if (process.env.NODE_ENV === "production") return false;
  if (typeof document === "undefined") return false;
  return getCookie("db_env") === "demo";
};

/** Technical details in error screens: development only, never in the demo. */
export const showDevDetails = (): boolean =>
  process.env.NODE_ENV === "development" && !isDemoDatabase();
